import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { AppRoutes } from "./routes.tsx";
import { InitialDataContext, type InitialData } from "./initial-data.ts";
import "./index.css";
import "./report.ts";

// 发布新版本之后,还开着旧页面的用户点进一个按需加载的路由,会去请求旧的 chunk 文件名,已经不存在了。
// Vite 在这种失败时发 vite:preloadError,这里的处理是整页刷新,拿新版本(第 24 章)
addEventListener("vite:preloadError", (e) => { e.preventDefault(); location.reload(); });
import "./vitals.ts";

// 服务端已经渲染过的页面带着 window.__DATA__:用同一份数据水合,不重新画。否则从空的 #root 开始
const data = (window as Window & { __DATA__?: InitialData }).__DATA__;
// 流式渲染的页面:评论在流的末尾才到,__DATA__ 里已经有了,包成 promise 给 Suspense 那一块水合用
const slug = location.pathname.match(/^\/p\/([a-z0-9-]+)\/?$/)?.[1];
if (data?.reviews && slug && data.reviews[slug]) data.reviewsPromise = Promise.resolve(data.reviews[slug]);
const tree = (
  <StrictMode>
    <InitialDataContext.Provider value={data ?? {}}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </InitialDataContext.Provider>
  </StrictMode>
);
const root = document.getElementById("root")!;
if (data) hydrateRoot(root, tree);
else createRoot(root).render(tree);
